import {React} from 'react'
import { Container,Row,Col } from 'react-bootstrap'
import ProductList from '../components/UI/ProductList'

const TrendingProducts = ({data,loading}) => {

    return (
        <section>
            <Container>
                <Row>
                    <Col lg='12' className='text-center mb-5'>
                        <h2 className='section__title'>Trending Products</h2>
                    </Col>
                    {
                        loading ? <h5 className='fw-bold'>Loading....</h5>:
                        <ProductList data={data} />
                    }
                </Row>
            </Container>
        </section>
    )
}

export default TrendingProducts